function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Button as ChakraButton } from '@chakra-ui/react';
import { useChakraPriorityStyles } from "../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
export var Button = props => {
  var styles = useChakraPriorityStyles(props);
  return /*#__PURE__*/_jsx(ChakraButton, _extends({}, props, styles));
};
Button.defaultProps = {
  textStyle: 'body-large-bold'
};
//# sourceMappingURL=Button.js.map